"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_css_grid_1 = require("styled-css-grid");
var hourcell_1 = __importDefault(require("./hourcell"));
var styled_components_1 = __importDefault(require("styled-components"));
var daylabelcell_1 = __importDefault(require("./daylabelcell"));
var _Grid = styled_components_1.default(styled_css_grid_1.Grid)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    grid-gap: 1px;\n    margin: 3px;\n    grid-auto-rows: 25px !important;\n    padding: 0px 4px;\n    background: ", ";\n    border-radius: 4px;\n"], ["\n    grid-gap: 1px;\n    margin: 3px;\n    grid-auto-rows: 25px !important;\n    padding: 0px 4px;\n    background: ", ";\n    border-radius: 4px;\n"])), function (props) { return props.isEven ? "rgb(0 0 0 / 2%)" : "rgb(0 0 0 / 4%)"; });
var HourRow = function (_a) {
    var dayOfWeek = _a.dayOfWeek, data = _a.data, scale = _a.scale, index = _a.index, popup = _a.popup;
    return (react_1.default.createElement(_Grid, { flow: "column", columns: 24, isEven: index % 2 == 0 },
        data.hours.map(function (hour, index) { return (react_1.default.createElement(hourcell_1.default, { height: 1, data: hour, scale: scale, key: "hour-" + index, popup: popup })); }),
        react_1.default.createElement(daylabelcell_1.default, { height: 1 }, dayOfWeek)));
};
exports.default = HourRow;
var templateObject_1;
